import { render, staticRenderFns } from "./UserChartsWidget.vue?vue&type=template&id=cddb9584&scoped=true"
import script from "./UserChartsWidget.vue?vue&type=script&lang=js"
export * from "./UserChartsWidget.vue?vue&type=script&lang=js"
import style0 from "./UserChartsWidget.vue?vue&type=style&index=0&id=cddb9584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddb9584",
  null
  
)

export default component.exports